var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"text-center mt-5 pt-5"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin fa-3x"})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }